import { render, staticRenderFns } from "./ActionDefaultLayout.vue?vue&type=template&id=077c6603&scoped=true"
import script from "./ActionDefaultLayout.vue?vue&type=script&lang=js"
export * from "./ActionDefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./ActionDefaultLayout.vue?vue&type=style&index=0&id=077c6603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c6603",
  null
  
)

export default component.exports